<template>
  <div class="save-info-container">
    <img :src="backgroundImage" alt="">
    <div class="save-info-form">
      <van-field
        v-model="form.userName"
        label="姓名"
        placeholder="请填写您的姓名"
      />
      <van-field
        v-model="form.mobile"
        type="tel"
        label="手机号"
        placeholder="请填写您的手机号"
      />
      <van-field
        v-model="form.veriCode"
        center
        clearable
        label="验证码"
        placeholder="请输入验证码"
      >
        <template #button>
          <!-- <van-button
            class="sendSMS"
            size="small"
            type="primary"
            :disabled="countDown"
            @click="sendSMS"
          >{{countDown ? `${countNumber} s` : '获取验证码'}}</van-button> -->
          <div class="van-field-t-div" @click="veriCodeClick">
            <img :src="codeUrl" />
          </div>
        </template>
      </van-field>
      <van-field
        v-model="form.carModel"
        is-link
        readonly
        :label="type === 'REL_MODEL' ? '意向车型' : '意向车款'"
        placeholder="请选择意向车型"
        @click="showCarType = true"
      />
      <van-field
        v-model="form.fieldValue"
        is-link
        readonly
        label="所属区域"
        placeholder="请选择所在地区"
        @click="showCityTree = true"
      />
      <van-field
        readonly
        is-link
        label="经销商"
        v-model="form.dealerName"
        placeholder="请选择经销商"
        @click="showDealer"
      />
      <!-- <div class="order-btn" @click="handleOrder">
        确定
      </div> -->
      <div class="order-btn" @click="handleOrder_2">
        确定
      </div>
    </div>
    <van-popup v-model="showCityTree" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="cityTree"
        :field-names="{
          text: 'cityName',
          value: 'cityNumber',
          children: 'children'
        }"
        @close="showCityTree = false"
        @finish="handleCitySelected"
      />
    </van-popup>
    <van-popup v-model="showCarType" round position="bottom">
      <!--<van-cascader
        v-model="cascadercarModel"
        title="请选择意向车型"
        :options="carModel"
        @close="showCarType = false"
        @finish="handleCarTypeSelected"
      />-->
      <van-picker
        show-toolbar
        title="请选择意向车型"
        :columns="carModel"
        value-key="modelName"
        @cancel="showCarType = false"
        @confirm="handleCarTypeSelected"
      />
      <!--@change="onChangeType"-->
    </van-popup>
    <van-popup v-model="showDealerList" round position="bottom">
      <van-picker
        show-toolbar
        :columns="filterDealer"
        @cancel="showDealerList = false"
        @confirm="handleDealerSelected"
      />
    </van-popup>
    <!--<van-popup v-model="showCarList" round position="bottom">-->
    <!--  <van-picker-->
    <!--    show-toolbar-->
    <!--    :columns="carList.map((v) => v.name)"-->
    <!--    @cancel="showCarList = false"-->
    <!--    @confirm="handleCarSelected"-->
    <!--  />-->
    <!--</van-popup>-->
  </div>
</template>

<script>
import { Toast } from 'vant'
import {
  sendSms,
  appointmentDrive,
  getCityTree2,
  getDealerList,
  getModelList,
  getPictureSessionId,
  getPictureCode,
  checkPictureCode
} from '@/api'
import pca from '@/assets/pca'
import { encryptAES128ECB } from '@/utils/crypto'

export default {
  name: 'SaveInfo',
  props: {
    backgroundImage: {
      type: String,
      default: ''
    },
    actiLargePostId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    activitySource: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cityLocation: pca.pca,
      form: {
        userName: null,
        mobile: null,
        veriCode: null,
        fieldValue: null,
        carModel: null,
        dealerName: null,
        carSeriesCode: null,
        carModelCode: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null
      },
      countDown: false,
      countNumber: 60,
      cascaderValue: null,
      cascadercarModel: null,
      cityTree: [],
      carModel: [],
      brands: [
        {
          name: '皮卡',
          code: 'QK005'
        },
        {
          name: '德沃斯',
          code: 'QK011'
        },
        {
          name: '工程车',
          code: 'QK006'
        },
        {
          name: '骏铃',
          code: 'QK002'
        },
        {
          name: '恺达',
          code: 'QK010'
        },
        {
          name: '康铃',
          code: 'QK001'
        },
        {
          name: '帅铃',
          code: 'QK003'
        }
      ],
      showCityTree: false,
      showCarType: false,
      showDealerList: false,
      showCarList: false,
      columns: [],
      filterDealer: [],
      dealerList: [],
      lat: '',
      lon: '',
      carList: [],
      imgBaseData: null,
      codeUrl: '',
      pictureCodeSessionId: ''
    }
  },
  watch: {
    actiLargePostId(val) {
      if (val) {
        /* getCarList({ actiLargePostId: val })
          .then((res) => {
            if (this.type === 'REL_MODEL') {
              this.carList = res.data.map((v) => ({
                value: v.modelId,
                name: v.modelName
              }))
            }
            if (this.type === 'REL_PATT') {
              this.carList = res.data[0].lalclp.map((v) => ({
                value: v.patternId,
                name: v.patternName
              }))
            }
          }) */
        getModelList({ id: val }).then((res) => {
          const { modelList } = res.data
          this.carModel = modelList
          // if (modelList) {
          //   this.carModel = [{
          //       values: modelList, // 设置的页面初始值
          //       className: 'column1'
          //     }, {
          //       values: modelList[0].children,
          //       className: 'column2'
          //     }
          //   ]
          // }
        })
      }
    }
  },
  methods: {
    sendSMS() {
      const { mobile } = this.form
      if (!this.countDown) {
        if (mobile === '') {
          Toast('请输入手机号')
        } else if (!/^1[3456789]\d{9}$/.test(mobile)) {
          Toast('请输入正确手机号')
        } else {
          const params = {
            sign: 9, // 0-注册或者登录、1-忘记密码、9-通用验证码
            phone: mobile
          }
          this.countDown = true
          sendSms(params)
            .then(() => {
              this.setCountDown()
              Toast('验证码发送成功')
            })
            .catch(() => {
              this.countDown = false
            })
        }
      }
    },
    setCountDown() {
      function sleep(interval) {
        return new Promise((resolve) => {
          setTimeout(resolve, interval)
        })
      }
      (async () => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 60; i++) {
          // eslint-disable-next-line no-plusplus
          this.countNumber--
          // eslint-disable-next-line no-await-in-loop
          await sleep(1000)
        }
        this.countDown = false
        this.countNumber = 60
      })()
    },
    // eslint-disable-next-line consistent-return
    showDealer() {
      const { carModelCode, fieldValue } = this.form
      if (!carModelCode) {
        return Toast('请选择意向车型')
      }
      if (!fieldValue) {
        return Toast('请选择所属区域')
      }
      // const car = this.carList.find((v) => v.name === carModel)
      const params = {
        pageNum: 1,
        pageSize: 1000,
        modelId: this.type === 'REL_MODEL' ? carModelCode : null
        // patternId: this.type === 'REL_PATT' ? car.value.split('S')[1] : null
      }
      getDealerList(params, { lat: this.lat, lon: this.lon }).then((res) => {
        this.dealerList = res.data.list
        if (res.data.list && this.dealerList.length) {
          this.showDealerList = true
          this.filterDealer = res.data.list.map((v) => v.dealerName)
        } else {
          Toast('暂无经销商')
        }
      })
    },
    handleCitySelected({ selectedOptions }) {
      this.form.provinceId = selectedOptions[0].cityNumber
      this.form.provinceName = selectedOptions[0].cityName
      this.form.cityId = selectedOptions[1].cityNumber
      this.form.cityName = selectedOptions[1].cityName
      const province = this.cityLocation.find(
        (v) => v.value === this.form.provinceId
      )
      const city = province.children.find((v) => v.value === this.form.cityId)
      this.lat = city.extra.lat
      this.lon = city.extra.lob
      this.showCityTree = false
      this.form.fieldValue = selectedOptions
        .map((option) => option.cityName)
        .join('/')
      this.form.dealerName = null
      this.form.dealer = null
    },
    handleDealerSelected(val) {
      this.form.dealerName = val
      this.form.dealer = this.dealerList.find((v) => v.dealer_name === val)
      this.showDealerList = false
    },
    handleCarTypeSelected(selectedOptions, value) {
      this.showCarType = false
      // eslint-disable-next-line prefer-destructuring
      // this.form.carSeriesCode = value[0]
      // eslint-disable-next-line prefer-destructuring
      this.form.carModelCode = this.carModel[value[0]].children[
        value[1]
      ].modelId
      this.form.carModel = selectedOptions.join('/')
      this.form.dealerName = null
      this.form.dealer = null
    },
    handleCarSelected(val) {
      this.form.carModel = val
      this.showCarList = false
    },
    // eslint-disable-next-line consistent-return
    handleOrder() {
      const {
        userName,
        mobile,
        veriCode,
        carModelCode,
        fieldValue,
        dealerName
      } = this.form
      if (!userName) {
        return Toast('请输入姓名')
      }
      if (!mobile) {
        return Toast('请输入手机号')
      }
      if (!veriCode) {
        return Toast('请输入验证码')
      }
      if (!carModelCode) {
        return Toast('请选择意向车型')
      }
      if (!fieldValue) {
        return Toast('请选择所属区域')
      }
      if (!dealerName) {
        return Toast('请选择经销商')
      }
      // const car = this.carList.find((v) => v.name === carModel)
      const dealer = this.dealerList.find((v) => v.dealerName === dealerName)
      // const carType = this.type === 'REL_PATT' ? car.value.substring(0, 1) : 'S'

      const key = '4x9KpLbR2QmN8sY8' // 密钥（需确保为16字节）
      const encryptedData = encryptAES128ECB(
        JSON.stringify({
          activitySource: this.activitySource, // 活动来源
          // carModelId: this.type === 'REL_MODEL' ? car.value : null,
          carModelId: carModelCode,
          // carType: 'S',
          dealerId: dealer.id,
          driver: userName, // 姓名
          locationSource: '', // 	位置来源
          mediumSource: '', // 媒体来源
          // patternId: this.type === 'REL_PATT' ? car.value.substring(1) : null,
          phone: mobile,
          veriCode
        }),
        key
      )
      appointmentDrive({ code: encryptedData })
        .then(() => {
          Toast('预约成功')
          this.$emit('appointment', { phone: mobile, name: userName })
        })
        .catch((err) => Toast(err.message))
    },
    // 获取图形验证码
    getPictureSessionIdFun() {
      const params = {}
      getPictureSessionId(params)
        .then((res) => {
          // eslint-disable-next-line quotes
          console.log("getPictureSessionId", res)
          this.pictureCodeSessionId = res
          sessionStorage.setItem('pictureCodeSessionId', res)
          this.getPictureCodeFun()
        })
        .catch((err) => {
          // eslint-disable-next-line quotes
          console.log("getPictureSessionId-err", err)
        })
    },
    // 获取图形验证码
    getPictureCodeFun() {
      const params = {
        sessionId: this.pictureCodeSessionId
      }
      getPictureCode(params)
        .then((res) => {
          // eslint-disable-next-line quotes
          console.log("getPictureCode", res)
          // eslint-disable-next-line prefer-const
          let blob = new Blob([res])
          // eslint-disable-next-line prefer-const
          let reader = new FileReader()
          // 传入需要被转换的文本流, 例如element-ui里的el-upload选择完返回的 file.raw
          reader.readAsDataURL(blob)
          // onload是异步的,封装的话可以用promise
          reader.onload = (e) => {
            // console.log("reader.onload",e)
            // 输出base64
            // console.log(reader.result)
            // eslint-disable-next-line prefer-destructuring, quotes
            this.imgBaseData = reader.result.split("base64,")[1]
            this.codeUrl = `data:image/png;base64,${this.imgBaseData}`
          }
        })
        .catch((err) => {
          // eslint-disable-next-line quotes
          console.log("getPictureCode-err", err)
        })
    },
    // 刷新图形验证码
    veriCodeClick() {
      this.getPictureCodeFun()
    },
    // eslint-disable-next-line consistent-return
    handleOrder_2() {
      const {
        userName,
        mobile,
        veriCode,
        carModelCode,
        fieldValue,
        dealerName
      } = this.form
      if (!userName) {
        return Toast('请输入姓名')
      }
      if (!mobile) {
        return Toast('请输入手机号')
      }
      if (!veriCode) {
        return Toast('请输入验证码')
      }
      if (!carModelCode) {
        return Toast('请选择意向车型')
      }
      if (!fieldValue) {
        return Toast('请选择所属区域')
      }
      if (!dealerName) {
        return Toast('请选择经销商')
      }

      if (!/^1[3456789]\d{9}$/.test(mobile)) {
        Toast('请输入正确手机号')
      } else {
        this.checkPictureCodeFun()
      }
    },
    // 图形验证码校验
    checkPictureCodeFun() {
      const key = '4x9KpLbR2QmN8sY8' // 密钥（需确保为16字节）
      const encryptedData = encryptAES128ECB(
        JSON.stringify({
          phone: this.form.mobile,
          code: this.form.veriCode,
          sessionId: this.pictureCodeSessionId
        }),
        key
      )

      checkPictureCode({ code: encryptedData })
        .then((res) => {
          // eslint-disable-next-line quotes
          console.log("checkPictureCode", res)
          // 1:验证通过 0:当前手机号已被冻结 -1:验证错误 -2:验证码过期
          if (res === 1) {
            this.handleOrder()
          } else if (res === 0) {
            Toast('当前手机号已被冻结')
          } else if (res === -1) {
            Toast('验证错误')
            this.form.veriCode = ''
            this.getPictureCodeFun()
          } else if (res === -2) {
            Toast('验证码过期')
            this.form.veriCode = ''
            this.getPictureCodeFun()
          }
        })
        .catch((err) => {
          // eslint-disable-next-line quotes
          console.log("checkPictureCode-err", err)
        })
    }
  },
  created() {
    getCityTree2()
      .then((res) => {
        this.cityTree = res.data
      })
      .catch((err) => console.log(err.message))

    const pictureCodeSessionId = sessionStorage.getItem('pictureCodeSessionId')
    if (!pictureCodeSessionId) {
      this.getPictureSessionIdFun()
    } else {
      this.pictureCodeSessionId = pictureCodeSessionId
      this.getPictureCodeFun()
    }
  }
}
</script>

<style scoped lang="scss">
.save-info-container {
  position: relative;
  img {
    width: 100%;
    display: block;
  }
  .save-info-form {
    position: absolute;
    top: 0;
    background-color: transparent;
    width: 100%;
    padding-left: rem(56);
    padding-right: rem(56);
    box-sizing: border-box;
    .van-cell::after {
      right: 0;
      left: 0;
    }
    .van-cell {
      background-color: #ffffff;
      padding-left: rem(22);
      padding-right: 0;
      height: rem(96);
      margin-bottom: rem(24);
      border-radius: rem(15);
      &:last-child::after {
        display: block;
      }
      ::v-deep {
        .van-icon-arrow {
          display: none;
        }
        .van-cell__title,
        .van-cell__value {
          line-height: 32.125px;
        }
        .van-field__label {
          font-size: rem(30);
          color: #333333;
          width: rem(150);
        }
        input,
        textarea {
          color: #333333;
          font-size: rem(30);
        }
        input::placeholder,
        textarea::placeholder {
          color: #cccccc;
        }
      }
      .sendSMS.van-button--primary {
        background-color: transparent;
        border: none;
        color: #333333;
      }
    }
    .order-btn {
      margin-top: rem(49);
      width: rem(638);
      height: rem(96);
      border-radius: 10px;
      background-image: -moz-linear-gradient(
        90deg,
        rgb(255, 247, 152) 0%,
        rgb(248, 212, 25) 100%
      );
      background-image: -webkit-linear-gradient(
        90deg,
        rgb(255, 247, 152) 0%,
        rgb(248, 212, 25) 100%
      );
      background-image: -ms-linear-gradient(
        90deg,
        rgb(255, 247, 152) 0%,
        rgb(248, 212, 25) 100%
      );
      box-shadow: 0px 6px 0px 0px rgba(218, 176, 7, 0.004);
      background-color: #ffffff;
      color: #9f0e12;
      font-size: rem(32);
      text-align: center;
      line-height: rem(96);
    }
  }

  .van-field-t-div {
    width: 92px;
    height: 32px;
    background-color: #909399;
    img {
      width: 92px;
      height: 32px;
    }
  }
}
</style>
